// Billing/Delivery tab toggle on the My Addresses page. Both panels are
// server-rendered (so a full page reload after add/edit/delete still lands
// on the right tab via the ?tab= param); this just switches between them
// without a reload when the shopper clicks a tab directly.

document.addEventListener('click', function (event) {
  var tab = event.target.closest('.js-addr-tabs .addr-tab')
  if (!tab) return

  var tabs = tab.closest('.js-addr-tabs')
  tabs.querySelectorAll('.addr-tab').forEach(function (other) {
    other.classList.toggle('is-active', other === tab)
  })

  var targetId = tab.dataset.tabTarget
  document.querySelectorAll('.addr-tab-panel').forEach(function (panel) {
    panel.hidden = panel.id !== targetId
  })
})
